// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import stat from '@infrastructure/shared/constant'
// ** Axios Imports
import axios from 'axios'

export const getGrade = createAsyncThunk('appSen/getGrade', async params => {
  const response = await axios.get(stat.URL_GRADE, { params })
  return {
    data: response.data
  }
})

export const getGradeKelas = createAsyncThunk('appSen/getGradeKelas', async (kode_grade, {params, getState })  => {
  const response = await axios.get(stat.URL_KELAS + kode_grade, { params })
  console.log('current state:', getState())
  return response.data
})

export const getMapel = createAsyncThunk('appSen/getMapel', async (id, { getState }) => {
  const add_url = "list/"
  const response = await axios.get(stat.URL_SEN + add_url + id)
  console.log('current state:', getState())
  return  {
    data: response.data
  }
})


export const getTujuanPembelajaran = createAsyncThunk('appSen/getTujuanPembelajaran', async (kode_pelajaran, { getState }) => {
  const add_url = "tujuan-pembelajaran/"
  const response = await axios.get(stat.URL_SEN + add_url + kode_pelajaran)
  console.log('current state:', getState())
  return response.data
})

export const postTujuanPembelajaran = createAsyncThunk('appSen/postTujuanPembelajaran', async (request, { dispatch, getState }) => {
  const add_url = "tujuan-pembelajaran"
  const response = await axios.post(stat.URL_SEN + add_url, request)
  await dispatch(getTujuanPembelajaran(getState().sen.kodePelajaran))
  return response.data
})

export const putTujuanPembelajaran = createAsyncThunk('appSen/putTujuanPembelajaran', async (request, { dispatch, getState }) => {
  const add_url = "tujuan-pembelajaran/"
  const response = await axios.put(stat.URL_SEN + add_url + request.id, request.payload)
  await dispatch(getTujuanPembelajaran(getState().sen.kodePelajaran))
  return response.data
})

export const delTujuanPembelajaran = createAsyncThunk('appSen/delTujuanPembelajaran', async (id_tp, { dispatch, getState }) => {
  const add_url = "tujuan-pembelajaran/"
  const response = await axios.delete(stat.URL_SEN + add_url + id_tp)
  await dispatch(getTujuanPembelajaran(getState().sen.kodePelajaran))
  return response.data
})

// =======================================================
// NILAI TUJUAN PEMBELAJARAN
// =======================================================

export const getNilaiTujuanPembelajaran = createAsyncThunk('appSen/getNilaiTujuanPembelajaran', async (param) => {
  const add_url = "tujuan-pembelajaran/nilai/"
  const separator = "/"
  console.log(param)
  const response = await axios.get(stat.URL_SEN + add_url + param.kode_pelajaran + separator + param.id_kelas)
  console.log(stat.URL_SEN + add_url + param.kode_pelajaran + separator + param.id_kelas)
  // console.log('current state:', getState())
  return response.data  
})

export const putNilaiTujuanPembelajaran = createAsyncThunk('appSen/putNilaiTujuanPembelajaran', async (request, { dispatch, getState }) => {
  const add_url = "tujuan-pembelajaran/nilai/"
  const separator = "/"
  const response = await axios.put(stat.URL_SEN + add_url  + getState().sen.kodePelajaran + separator + getState().sen.idKelas, request)
  const param = {
    kode_pelajaran: getState().sen.kodePelajaran,
    id_kelas: getState().sen.idKelas
  }
  await dispatch(getNilaiTujuanPembelajaran(param))
  return response.data
})


// ============================================================
// Nilai Lingkup Materi
// ============================================================

export const getNilaiLingkupMateri = createAsyncThunk('appSen/getNilaiLingkupMateri', async (param) => {
  const add_url = "lingkup-materi/nilai/"
  const separator = "/"
  console.log(param)
  const response = await axios.get(stat.URL_SEN + add_url + param.kode_pelajaran + separator + param.id_kelas)
  console.log(stat.URL_SEN + add_url + param.kode_pelajaran + separator + param.id_kelas)
  // console.log('current state:', getState())
  return response.data  
})

export const putNilaiLingkupMateri = createAsyncThunk('appSen/putNilaiLingkupMateri', async (request, { dispatch, getState }) => {
  const add_url = "lingkup-materi/nilai/"
  const separator = "/"
  const response = await axios.put(stat.URL_SEN + add_url + getState().sen.kodePelajaran + separator + getState().sen.idKelas, request)
  const param = {
    kode_pelajaran: getState().sen.kodePelajaran,
    id_kelas: getState().sen.idKelas
  }
  await dispatch(getNilaiLingkupMateri(param))
  return response.data
})


// CAPAIAN KOMPETENSI

export const getCapaianLevel = createAsyncThunk('appSen/getCapaianLevel', async ({ getState }) => {
  const add_url = "capaian-level"
  const response = await axios.get(stat.URL_SEN + add_url)
  console.log('current state:', getState())
  return response.data  
})

export const getCapaianKompetensiList = createAsyncThunk('appSen/getCapaianKompetensiList', async (param)  => {
  const add_url = "nilai/capaian-kompetensi/"
  const separator = "/"
  const response = await axios.get(stat.URL_SEN + add_url + param.kode_pelajaran + separator + param.id_kelas)
  return response.data
})

export const putSen = createAsyncThunk('appSen/putSen', async (request, { dispatch, getState }) => {
  const add_url = "nilai/capaian-kompetensi"
  const response = await axios.put(stat.URL_SEN + add_url, { request })
  await dispatch(getCapaianKompetensiList(getState().sen.kodePelajaran, getState().sen.idKelas))
  return response.data
})

// NILAI MATA PELAJARAN

export const getPelajaranNilaiList = createAsyncThunk('appSen/getPelajaranNilaiList', async (request) => {
  const add_url = "nilai/"
  const separator = "/"
  const response = await axios.get(stat.URL_SEN + add_url + request.kode_pelajaran + separator + request.id_kelas)
  return response.data
})

export const putPelajaranNilai = createAsyncThunk('appSen/putPelajaranNilai', async (request, { dispatch, getState }) => {
  const add_url = "nilai/"
  const separator = "/"
  const response = await axios.put(stat.URL_SEN + add_url + getState().sen.kodePelajaran + separator + getState().sen.idKelas, {
    data_nilai: request
  })

  const param = {
    kode_pelajaran: getState().sen.kodePelajaran,
    id_kelas: getState().sen.idKelas
  }

  await dispatch(getPelajaranNilaiList(param))
  return response.data
})

// =======================================================
//  LINGKUP MATERI
// =======================================================

export const getLingkupMateri = createAsyncThunk('appSen/getLingkupMateri', async (kode_pelajaran, { getState }) => {
  const add_url = "lingkup-materi/"
  const response = await axios.get(stat.URL_SEN + add_url + kode_pelajaran)
  console.log('current state:', getState())
  return response.data
})

export const postLingkupMateri = createAsyncThunk('appSen/postLingkupMateri', async (request, { dispatch, getState }) => {
  const add_url = "lingkup-materi"
  const response = await axios.post(stat.URL_SEN + add_url, request)
  await dispatch(getLingkupMateri(getState().sen.kodePelajaran))
  return response.data
})

export const putLingkupMateri = createAsyncThunk('appSen/putLingkupMateri', async (request, { dispatch, getState }) => {
  console.log({request})
  const add_url = "lingkup-materi/"
  const response = await axios.put(stat.URL_SEN + add_url + request.id, request.payload)
  await dispatch(getLingkupMateri(getState().sen.kodePelajaran))
  return response.data
})

export const delLingkupMateri = createAsyncThunk('appSen/delLingkupMateri', async (id_tp, { dispatch, getState }) => {
  const add_url = "lingkup-materi/"
  const response = await axios.delete(stat.URL_SEN + add_url + id_tp)
  await dispatch(getLingkupMateri(getState().sen.kodePelajaran))
  return response.data
})

  
export const getTasks = createAsyncThunk('appSen/getTasks', async params => {
  const response = await axios.get(stat.URL_GRADE, { params })
    // '/apps/todo/tasks'
    // console.log(response.data.data)

  return {
    params,
    data: response.data
  }
})


export const appSenSlice = createSlice({
  name: 'appSen',
  initialState: {
    grade: [],
    statusLoadGrade: null,
    mapel: [],
    statusMapelGrade: null,
    tujuanPembelajaran: [],
    selectedTujuanPembelajaran: {},
    nilaiTujuanPembelajaran: [],
    nilaiLingkupMateri: [],
    nilaiCapaianKompetensi: [],
    nilaiPelajaran: [],
    statusTujuanPembelajaran: null,
    statusNilaiTujuanPembelajaran: null,
    statusNilaiLingkupMateri: null,
    statusSen: null,
    statusNilaiPelajaran: null,
    lingkupMateri:[],
    selectedLingkupMateri: {},
    statusLingkupMateri: null,
    kelas: [],
    idKelas: null,
    statusIdKelas: null,
    kodeGrade: null,
    kodePelajaran: null,
    idPelajaran:null,
    statusPostLingkupMateri: null,
    statusPutLingkupMateri: null,
    statusDelLingkupMateri: null,
    responsePostLingkupMateri: null, 
    responsePutLingkupMateri: null, 
    statusPostTujuanPembelajaran: null, 
    statusPutTujuanPembelajaran: null, 
    statusDelTujuanPembelajaran: null,
    responsePostTujuanPembelajaran: null,
    responsePutTujuanPembelajaran: null,

    statusPutNilaiTujuanPembelajaran: null, 
    responsePutNilaiTujuanPembelajaran: null,

    statusPutNilaiLingkupMateri: null, 
    responsePutNilaiLingkupMateri: null,

    statusPutPelajaranNilai: null, 
    responsePutPelajaranNilai: null,
    // selectedTask: {},
    params: {
      filter: '',
      q: '',
      sort: '',
      tag: ''
    }
  },
  reducers: {
    reOrderTasks: (state, action) => {
      state.data = action.payload
      
    },
    selectTask: (state, action) => {
      state.selectedTask = action.payload
    },
    selectIdKelas: (state, action) => {
      state.idKelas = action.payload
    },
    selectKodeGrade: (state, action) => {
      state.kodeGrade = action.payload
    },
    selectKodePelajaran: (state, action) => {
      state.kodePelajaran = action.payload
    },
    selectIdPelajaran: (state, action) => {
      state.idPelajaran = action.payload
    },
    setNilaiTujuanPembelajaran: (state, action) => {
      state.nilaiTujuanPembelajaran = action.payload
    },
    setNilaiLingkupMateri: (state, action) => {
      state.nilaiLingkupMateri = action.payload
    },
    setPelajaranNilai: (state, action) => {
      state.nilaiPelajaran = action.payload
    },
    selectTujuanPembelajaran: (state, action) => {
      state.selectedTujuanPembelajaran = action.payload
    },
    selectLingkupMateri: (state, action) => {
      state.selectedLingkupMateri = action.payload
    },
    stateResetLingkupMateri: (state) => {
      state.statusPostLingkupMateri = 'loading'
      state.statusPutLingkupMateri = 'loading'
      state.statusDelLingkupMateri = 'loading'
    },
    stateResetTujuanPembelajaran: (state) => {
      state.statusPostTujuanPembelajaran = 'loading'
      state.statusPutTujuanPembelajaran = 'loading'
      state.statusDelTujuanPembelajaran = 'loading'
    },
    stateResetNilaiTujuanPembelajaran: (state) => {
      state.statusPutNilaiTujuanPembelajaran = 'loading'
    },
    stateResetNilaiLingkupMateri: (state) => {
      state.statusPutNilaiLingkupMateri = 'loading'
    },
    stateResetPelajaranNilai: (state) => {
      state.statusPutPelajaranNilai = 'loading'
    }
    
  },
  extraReducers: builder => {
    
    builder.addCase(getGrade.fulfilled, (state, action) => {
      state.grade = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getMapel.pending, (state, action) => {
      console.log("loading", action.payload)
      state.statusMapelGrade = 'loading'
      // state.params = action.payload.params
    })
    builder.addCase(getMapel.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      console.log("Full filled", action.payload.data)
      state.statusMapelGrade = 'loaded'
      state.mapel = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getGradeKelas.pending, (state) => {
      state.statusIdKelas = 'loading'
    })
    builder.addCase(getGradeKelas.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      console.log("Full filled Kelas", action.payload.data)
      state.statusIdKelas = 'loaded'
      state.kelas = action.payload.data
      state.params = action.payload.params
    })
    // POST, PUT, DEL Lingkup Materi 
    builder.addCase(postLingkupMateri.pending, (state) => {
      state.statusPostLingkupMateri = 'loading'
    })
    builder.addCase(postLingkupMateri.fulfilled, (state, action) => {
      state.statusPostLingkupMateri = 'loaded'
      state.responsePostLingkupMateri = action.payload
    })
    builder.addCase(postLingkupMateri.rejected, (state, action) => {
      state.statusPostLingkupMateri = 'failed'
      state.responsePostLingkupMateri = action.error
    })

    builder.addCase(putLingkupMateri.pending, (state) => {
      state.statusPutLingkupMateri = 'loading'
    })
    builder.addCase(putLingkupMateri.fulfilled, (state, action) => {
      state.statusPutLingkupMateri = 'loaded'
      state.responsePutLingkupMateri = action.payload
    })
    builder.addCase(putLingkupMateri.rejected, (state, action) => {
      state.statusPutLingkupMateri = 'failed'
      state.responsePutLingkupMateri = action.error
    })

    builder.addCase(delLingkupMateri.pending, (state) => {
      state.statusDelLingkupMateri = 'loading'
    })
    builder.addCase(delLingkupMateri.fulfilled, (state) => {
      state.statusDelLingkupMateri = 'loaded'
    })
    builder.addCase(delLingkupMateri.rejected, (state) => {
      state.statusDelLingkupMateri = 'failed'
    })


     // POST, PUT, DEL Tujuan Pembelajaran
     builder.addCase(postTujuanPembelajaran.pending, (state) => {
      state.statusPostTujuanPembelajaran = 'loading'
    })
    builder.addCase(postTujuanPembelajaran.fulfilled, (state, action) => {
      state.statusPostTujuanPembelajaran = 'loaded'
      state.responsePostTujuanPembelajaran = action.payload
    })
    builder.addCase(postTujuanPembelajaran.rejected, (state, action) => {
      state.statusPostTujuanPembelajaran = 'failed'
      state.responsePostTujuanPembelajaran = action.error
    })

    builder.addCase(putTujuanPembelajaran.pending, (state) => {
      state.statusPutTujuanPembelajaran = 'loading'
    })
    builder.addCase(putTujuanPembelajaran.fulfilled, (state, action) => {
      state.statusPutTujuanPembelajaran = 'loaded'
      state.responsePutTujuanPembelajaran = action.payload
    })
    builder.addCase(putTujuanPembelajaran.rejected, (state, action) => {
      state.statusPutTujuanPembelajaran = 'failed'
      state.responsePutTujuanPembelajaran = action.error
    })

    builder.addCase(delTujuanPembelajaran.pending, (state) => {
      state.statusDelTujuanPembelajaran = 'loading'
    })
    builder.addCase(delTujuanPembelajaran.fulfilled, (state) => {
      state.statusDelTujuanPembelajaran = 'loaded'
    })
    builder.addCase(delTujuanPembelajaran.rejected, (state) => {
      state.statusDelTujuanPembelajaran = 'failed'
    })

    builder.addCase(putNilaiTujuanPembelajaran.pending, (state) => {
      state.statusPutNilaiTujuanPembelajaran = 'loading'
    })
    builder.addCase(putNilaiTujuanPembelajaran.fulfilled, (state, action) => {
      state.statusPutNilaiTujuanPembelajaran = 'loaded'
      state.responsePutNilaiTujuanPembelajaran = action.payload
    })
    builder.addCase(putNilaiTujuanPembelajaran.rejected, (state, action) => {
      state.statusPutNilaiTujuanPembelajaran = 'failed'
      state.responsePutNilaiTujuanPembelajaran = action.error
    })

    // Nilai Lingkup Materi
    builder.addCase(getNilaiLingkupMateri.pending, (state) => {
      state.statusNilaiLingkupMateri = 'loading'
    })
    builder.addCase(getNilaiLingkupMateri.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      // console.log("Full filled", action.payload.data)
      state.statusNilaiLingkupMateri = 'loaded'
      state.nilaiLingkupMateri = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(putNilaiLingkupMateri.pending, (state) => {
      state.statusPutNilaiLingkupMateri = 'loading'
    })
    builder.addCase(putNilaiLingkupMateri.fulfilled, (state, action) => {
      state.statusPutNilaiLingkupMateri = 'loaded'
      state.responsePutNilaiLingkupMateri = action.payload
    })
    builder.addCase(putNilaiLingkupMateri.rejected, (state, action) => {
      state.statusPutNilaiLingkupMateri = 'failed'
      state.responsePutNilaiLingkupMateri = action.error
    })

    // // Deskripsi Lingkup Materi
    // // ==========================================================
    //   builder.addCase(getCapaianKompetensiList.pending, (state) => {
    //     state.statusSen = 'loading'
    //   })
    //   builder.addCase(getCapaianKompetensiList.fulfilled, (state, action) => {
    //     console.log("loaded", action.payload.data)
    //     // console.log("Full filled", action.payload.data)
    //     state.statusSen = 'loaded'
    //     state.nilaiCapaianKompetensi = action.payload.data
    //     state.params = action.payload.params
    //   })

    // Pelajaran Nilai 
    // ==========================================================
    builder.addCase(putPelajaranNilai.pending, (state) => {
      state.statusPutPelajaranNilai = 'loading'
    })
    builder.addCase(putPelajaranNilai.fulfilled, (state, action) => {
      state.statusPutPelajaranNilai = 'loaded'
      state.responsePutPelajaranNilai = action.payload
    })
    builder.addCase(putPelajaranNilai.rejected, (state, action) => {
      state.statusPutPelajaranNilai = 'failed'
      state.responsePutPelajaranNilai = action.error
    })
    // ==========================================================
    // Tujuan Pembelajaran
    // ==========================================================

    builder.addCase(getTujuanPembelajaran.pending, (state) => {
      state.statusTujuanPembelajaran = 'loading'
    })
    builder.addCase(getTujuanPembelajaran.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      // console.log("Full filled", action.payload.data)
      state.statusTujuanPembelajaran = 'loaded'
      state.tujuanPembelajaran = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getLingkupMateri.pending, (state) => {
      state.statusLingkupMateri = 'loading'
    })
    builder.addCase(getLingkupMateri.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      // console.log("Full filled", action.payload.data)
      state.statusLingkupMateri = 'loaded'
      state.lingkupMateri = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getNilaiTujuanPembelajaran.pending, (state) => {
      state.statusNilaiTujuanPembelajaran = 'loading'
    })
    builder.addCase(getNilaiTujuanPembelajaran.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      // console.log("Full filled", action.payload.data)
      state.statusNilaiTujuanPembelajaran = 'loaded'
      state.nilaiTujuanPembelajaran = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getPelajaranNilaiList.pending, (state) => {
      state.statusNilaiPelajaran = 'loading'
    })
    builder.addCase(getPelajaranNilaiList.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      // console.log("Full filled", action.payload.data)
      state.statusNilaiPelajaran = 'loaded'
      state.nilaiPelajaran = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getCapaianKompetensiList.pending, (state) => {
      state.statusSen = 'loading'
    })
    builder.addCase(getCapaianKompetensiList.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      // console.log("Full filled", action.payload.data)
      state.statusSen = 'loaded'
      state.nilaiCapaianKompetensi = action.payload.data
      state.params = action.payload.params
    })
    
  }
})

export const { reOrderTasks, selectTask, selectIdKelas, selectKodeGrade, selectKodePelajaran, selectIdPelajaran, selectTujuanPembelajaran, selectLingkupMateri, stateResetLingkupMateri, stateResetTujuanPembelajaran, setNilaiTujuanPembelajaran, stateResetNilaiTujuanPembelajaran, stateResetNilaiLingkupMateri, setNilaiLingkupMateri, setPelajaranNilai, stateResetPelajaranNilai} = appSenSlice.actions

export default appSenSlice.reducer
